import isNil from 'lodash.isnil';
import countBy from 'lodash.countby';
import {
    getMeasureInterpsFromResults,
    getInterpsForPeriodFromResults,
} from '../../../utils/shared/filterUtils';
import { INTERP, PERIOD } from '../../../constants/shared/CommonConstants';
import { getPercentageOfNumber } from '../shared/featureReportHelper';
import getAvailableMeasuresForView from './featureReportHelper';
import { getAvailablePeriods } from '../../../utils/shared/tableUtils';

const { RED, YELLOW, GREEN, BLUE, PROFICIENT, BELOW } = INTERP;

const calcStudentsNumberByInterps = (interps, column) => {
    const studentsCount = countBy(interps)[column];
    return isNil(studentsCount) ? 0 : studentsCount;
};
const getStats = interps => {
    const proficientStudentsNumber = calcStudentsNumberByInterps(interps, [PROFICIENT]);
    const belowStudentsNumber = calcStudentsNumberByInterps(interps, [BELOW]);
    const redStudentsNumber = calcStudentsNumberByInterps(interps, [RED]);
    const yellowStudentsNumber = calcStudentsNumberByInterps(interps, [YELLOW]);
    const greenStudentsNumber = calcStudentsNumberByInterps(interps, [GREEN]);
    const blueStudentsNumber = calcStudentsNumberByInterps(interps, [BLUE]);

    return {
        redStudentsNumber,
        yellowStudentsNumber,
        greenStudentsNumber,
        blueStudentsNumber,
        proficientStudentsNumber,
        belowStudentsNumber,
        totalStudentsNumberTRO:
            redStudentsNumber + yellowStudentsNumber + greenStudentsNumber + blueStudentsNumber,
        totalStudentsNumberDO: proficientStudentsNumber + belowStudentsNumber,
        totalStudentsNumber:
            redStudentsNumber +
            yellowStudentsNumber +
            greenStudentsNumber +
            blueStudentsNumber +
            proficientStudentsNumber +
            belowStudentsNumber,
    };
};

const getPercentage = stats => ({
    redPercentage: getPercentageOfNumber(stats.redStudentsNumber, stats.totalStudentsNumberTRO),
    yellowPercentage: getPercentageOfNumber(
        stats.yellowStudentsNumber,
        stats.totalStudentsNumberTRO,
    ),
    greenPercentage: getPercentageOfNumber(stats.greenStudentsNumber, stats.totalStudentsNumberTRO),
    bluePercentage: getPercentageOfNumber(stats.blueStudentsNumber, stats.totalStudentsNumberTRO),
    proficientPercentage: getPercentageOfNumber(
        stats.proficientStudentsNumber,
        stats.totalStudentsNumberDO,
    ),
    belowPercentage: getPercentageOfNumber(stats.belowStudentsNumber, stats.totalStudentsNumberDO),
});

const getPerformanceByInterps = interps => {
    const stats = getStats(interps);
    const percentage = getPercentage(stats);
    return {
        red: {
            percentage: percentage.redPercentage,
            studentsTotalNumber: stats.redStudentsNumber,
        },
        yellow: {
            percentage: percentage.yellowPercentage,
            studentsTotalNumber: stats.yellowStudentsNumber,
        },
        green: {
            percentage: percentage.greenPercentage,
            studentsTotalNumber: stats.greenStudentsNumber,
        },
        blue: {
            percentage: percentage.bluePercentage,
            studentsTotalNumber: stats.blueStudentsNumber,
        },
        proficient: {
            percentage: percentage.proficientPercentage,
            studentsTotalNumber: stats.proficientStudentsNumber,
        },
        below: {
            percentage: percentage.belowPercentage,
            studentsTotalNumber: stats.belowStudentsNumber,
        },
    };
};

const getOverallPerformanceExpress = (
    currentPeriod,
    selectedPeriod,
    grades,
    overalls,
    measures,
    gradeToMeasureMapper,
    toyPeriods,
) => {
    const performanceByMeasures = {
        red: [],
        yellow: [],
        green: [],
        blue: [],
        below: [],
        proficient: [],
    };
    if (selectedPeriod === PERIOD.SUMMARY) {
        const availablePeriods = getAvailablePeriods(currentPeriod);
        toyPeriods.forEach(period => {
            if (availablePeriods.includes(period)) {
                const interps = getInterpsForPeriodFromResults(overalls, period);
                const performance = getPerformanceByInterps(interps);
                Object.keys(performance).forEach(level =>
                    performanceByMeasures[level].push({
                        isAvailible: true,
                        value: performance[level],
                    }),
                );
            } else {
                Object.keys(performanceByMeasures).forEach(level =>
                    performanceByMeasures[level].push({ isAvailible: false, value: '-' }),
                );
            }
        });
    } else {
        const interpsByMeasure = [];
        getAvailableMeasuresForView(grades, measures, gradeToMeasureMapper).forEach(measure => {
            interpsByMeasure.push(...getMeasureInterpsFromResults(overalls, measure.key));
        });
        const performance = getPerformanceByInterps(interpsByMeasure);
        Object.keys(performance).forEach(level =>
            performanceByMeasures[level].push({ isAvailible: true, value: performance[level] }),
        );
    }
    return performanceByMeasures;
};

export default getOverallPerformanceExpress;
